<template lang="jade">
	//-include ../../node_modules/tangram-ui/src/elements/tge-componenttitle/tge-componenttitle.jade
	
	.asw-poll(v-if="properties")
		//-.asw-poll_close(@click="closeClick")
			+tge-svg-icons({ icon: "close" })
		transition(appear, name="fade", mode="out-in")
			//-template
			.asw-poll_inner(:key="properties.Elect_div")
				.asw-poll-question(v-if="!votedCookie")|{{ pollQuestion }}
				.asw-poll-question_answered(v-else)|{{ pollQuestionAnswered }}
					
				.asw-poll_title
					|{{ properties.Elect_div }}, {{ properties.electorate_state }} ?

				.asw-poll_question(v-if="!votedCookie")
					.asw-poll_question_hint
						|{{ sliderHelp }}

					.asw-poll_slider(:class="pollValue")
						vue-slider(v-model="pollValue", :data="sliderData", :marks="true", :process="false")

					.asw-poll_submit.button(@click="submitClick")
						|{{ 'submit' }}

				.asw-poll_result(v-if="votedCookie && results")
					
					.asw-poll_result_chart(v-if="chart_poll_total > 0")
						svg.asw-poll_result_chart_svg(:width="chart_poll.width", :height="chart_poll.height")
							g.poll_svg_g(:transform="chart_poll_transform")
								g.arc(v-for="item in chart_poll_paths")
									path(:d="item.d", :style="{ fill: item.fill }")
									g.arcText(v-if="item.data.value > 0")
										text(:transform="item.pieTexttransform", :style="{ fill: item.fill, 'text-anchor': 'middle' }", x='0', y='0' ) 
											tspan.value(x="0", dy="1.2em") {{ item.data.value }}% 
											tspan.name(x="0", dy="1.2em") {{ item.data.name}}
										image.icon(v-if="item.data.value > 9", :transform="item.pieTexttransform", width=45, height=45, x=30, y=-2, :href="item.b64icon" )

					.asw-poll_result_novotes(v-if="chart_poll_total === 0")|{{ pollNoResults }}

				.asw-poll_close.button(@click="closeClick")|{{ 'close' }}	
</template>
<script>

	import d3arc from "d3-shape/src/arc";
	import d3pie from "d3-shape/src/pie";

	import VueSlider from 'vue-slider-component'
	import 'vue-slider-component/theme/default.css'
	import axios from 'axios'

	export default {
		name: "poll",
		components: {
			VueSlider
		},
		props: {
			pollData: {
				type: Object
			},
			emojiData: {
				type: Object,
				required: true
			},
			environ: {
				type: String
			},
			resultDate: {
				type: Number
			}
		},
		data: () => ({
			pollNoResults: 'Unfortunately there are no results yet',
			sliderHelp: 'Drag the slider to make your selection',
			chart_poll: {
				width: 180,
				height: 180
			},
			pollValue: 'meh',
			sliderData: ['furious', 'depressed', 'worried', 'meh', 'happy', 'stoked'],
			votedCookie:null,
			results:null,
			isMobile: null
		}),
		computed: {
			pollQuestion() {
                const 
                    question = 'How do you feel about the election in',
					questionElectionNight = "How do you feel about the election results in";
				return ( Date.now() > this.resultDate ) ? questionElectionNight: question;
			},
			pollQuestionAnswered() {
                const 
                    questionAnswered = 'How do people feel about the election in',
					questionAnsweredElectionNight = "How do people feel about the election results in";
				return ( Date.now() > this.resultDate ) ? questionAnsweredElectionNight: questionAnswered;
			},
			pie() {
				return d3pie().sort(null).value(function(d) { return d.value; });
			},
			chart_poll_transform() {
				return "translate(" + this.chart_poll.width / 2 + "," + this.chart_poll.height / 2 + ")";
			},
			chart_poll_total() {
				return this.results.total;
			},
			chart_poll_data() {
				
				return [
					{ name: 'furious', value: this.results.votes.furious.pc },
					{ name: 'depressed', value: this.results.votes.depressed.pc },
					{ name: 'worried', value: this.results.votes.worried.pc },
					{ name: 'meh', value: this.results.votes.meh.pc },
					{ name: 'happy', value: this.results.votes.happy.pc },
					{ name: 'stoked', value: this.results.votes.stoked.pc }
				];
				
			},
			chart_poll_paths() {
				const
					radius = Math.min(this.chart_poll.width, this.chart_poll.height) / 2,
					//arc = d3arc().outerRadius(radius - 10).innerRadius(radius - 35),
					arc = this.isMobile ? d3arc().outerRadius(radius - 10).innerRadius(radius - 25) : d3arc().outerRadius(radius - 10).innerRadius(radius - 35),
					pieData = this.pie(this.chart_poll_data);

				return pieData.map((d) => ({
					...d,
					d: arc(d),
					fill: this.emojiColorFn(d.data.name),
					pieTexttransform: this.pietext_transform( arc.centroid(d), d ),
					b64icon: this.emojiIconFn(d.data.name)
				}) );

			},
			properties() {
				return this.pollData.properties;
			}
		},
		mounted() {
			//console.log(this)
			this.checkMobile();

			window.addEventListener('resize', this.checkMobile );
			window.addEventListener('orientationchange', this.checkMobile );
		},
		created() {
			this.getCookie();
		},
		methods: {
			checkMobile() {

				const mq = window.matchMedia( "(max-width: 500px)" );

				if (mq.matches) {
					this.isMobile = true;
					this.chart_poll.width = 100;
					this.chart_poll.height = 100;
				} else {
					this.isMobile = false;
					this.chart_poll.width = 180;
					this.chart_poll.height = 180;
				}
				
			},
			submitClick() {
				//console.log('Sentiment', this.pollValue, this.properties.Elect_div, this.properties.fid);
				if (this.pollValue) {
					this.postPoll();
				}
			},
			closeClick() {
				this.$emit('close');
			},
			postPoll() {
				//console.log('Should Post this:', this.pollValue, this.properties.Elect_div, this.properties.fid);
				const 
					// localUrl = 'http://localhost:5000/api/electorate/' + this.properties.fid + '/vote',
					uatUrl = 'https://d3l0ncuayaqpnv.cloudfront.net/api/electorate/' + this.properties.fid + '/vote',
                    prodUrl = 'https://d1pg15zwxj87d2.cloudfront.net/api/electorate/' + this.properties.fid + '/vote',
                    postUrl = this.environ.match(/development|uat/) ? uatUrl : prodUrl ;
				
				// const postUrl = 'https://znj95mx1a2.execute-api.ap-southeast-2.amazonaws.com/uat/api/electorate/' + this.properties.fid + '/vote';
				//const pollFormData = {'vote': this.pollValue, 'token': 'asdf1234'}
				const token = this.createToken();
				const capiMeta = document.querySelector('meta[name="articleid"]');
				const capiid = capiMeta && capiMeta.getAttribute('content');
			
				const indexPath = !capiid ? window.location.pathname : null;
				//const skipCookie = true;
				const pollFormDataUat = { 'vote': this.pollValue, token, capiid, indexPath, skipCookie:true };
				const pollFormDataProd = { 'vote': this.pollValue, token, capiid, indexPath };
				const pollFormData = this.environ.match(/development|uat/) ? pollFormDataUat : pollFormDataProd ;
				
				axios
					.post(postUrl, pollFormData, { withCredentials: true })
					.then(response => {
						if(response.status == 200){
							const b64votevalue = Buffer.from(this.pollValue).toString('base64');
							let exDate = new Date();
							exDate.setTime(exDate.getTime() + (1*24*60*60*1000));
							const cookExpires = "expires="+ exDate.toUTCString();
							
							// LINE DISABLED TEMPORARILY TO TEST, OTHERWISE 24 HOURS BUDDY
							document.cookie = "_asw=V" + b64votevalue + ";" + cookExpires + ";path=/";
							
							this.votedCookie = this.pollValue;
							
							setTimeout(() => { this.getPollResults(token) }, 1000);

						}

					})
					.catch(error => {
                    //.catch(function (error) {
						console.log(error);
						
						// get results regardless
						this.votedCookie = 'true';
						// set cookie for 403
						let exDate = new Date();
						exDate.setTime(exDate.getTime() + (1*24*60*60*1000));
						const cookExpires = "expires="+ exDate.toUTCString();
						document.cookie = "_asw=AV" + "403" + ";" + cookExpires + ";path=/";
						setTimeout(() => { this.getPollResults(token) }, 1000);

                    });
      
				/*
				const response = await axios
					.post(postUrl, pollFormData)
					.then(response => {
				*/

			},
			getPollResults(token) {
				const tokenParam = token ? '?_t=' + token : ''

				const
					uatUrl = 'https://d3l0ncuayaqpnv.cloudfront.net/api/electorate/' + this.properties.fid + '/results' + tokenParam,
					prodUrl = 'https://d1pg15zwxj87d2.cloudfront.net/api/electorate/' + this.properties.fid + '/results' + tokenParam,
					getUrl = this.environ.match(/development|uat/) ? uatUrl : prodUrl ;
				
				//const getUrl = 'https://znj95mx1a2.execute-api.ap-southeast-2.amazonaws.com/uat/api/electorate/' + this.properties.fid + '/results';
				axios.get(getUrl)
                    .then((response) => {
						if(response.status == 200){
							this.results = response.data.data;
						}
					})
                    .catch(function (error) {
                        console.log(error);
                    });
			},
            getCookie() {
                const cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)_asw\s*\=\s*([^;]*).*$)|^.*$/, "$1");
				if (cookieValue !== '') {
                    const deB64value = cookieValue.substr(1); // remove the sneaky V
                    const sentiment = new Buffer(deB64value, 'base64').toString();
					this.votedCookie = sentiment;
					this.getPollResults();
                }
			},
			emojiColorFn(name) {
				return this.emojiData[name].color;
			},
			emojiIconFn(name) {
				return this.emojiData[name].iconB64;
			},
			pietext_transform(arcCentroid, d) {
				
				const dangle = (d.endAngle + d.startAngle)/2;
				//console.log('dangle', dangle);

				if (this.isMobile) {
					if (dangle > 0 && dangle <= 1.0 ) {
						arcCentroid[0] *= 2.5;
						arcCentroid[1] *= 3.0;
						//console.log('1mobile');
					} else if (dangle > 1 && dangle <= 1.9 ) {
						arcCentroid[0] *= 2.6;
						arcCentroid[1] *= 2.6;
						//console.log('2mobile');
					} else if (dangle > 1.9 && dangle <= 3 ) {
						arcCentroid[0] *= 2.3;
						arcCentroid[1] *= 2.3;
						//console.log('3mobile');
					} else if (dangle > 3 && dangle <= 4.2 ) {
						arcCentroid[0] *= 4.8;
						arcCentroid[1] *= 2.1;
						//console.log('4mobile');
					} else if (dangle > 4.2 && dangle <= 5.0 ) {
						arcCentroid[0] *= 4.0;
						arcCentroid[1] *= 1.0;
						//console.log('5mobile');
					} else {
						arcCentroid[0] *= 4.5;
						arcCentroid[1] *= 3.3;
						//console.log('6mobile');
					}

				} else {
					if (dangle > 0 && dangle <= 1.0 ) {
						arcCentroid[0] *= 2.0;
						arcCentroid[1] *= 2.0;
						//console.log('1');
					} else if (dangle > 1 && dangle <= 1.8 ) {
						arcCentroid[0] *= 1.8;
						arcCentroid[1] *= 2.0;
						//console.log('2');
					} else if (dangle > 1.8 && dangle <= 3 ) {
						arcCentroid[0] *= 1.7;
						arcCentroid[1] *= 1.2;
						//console.log('3');
					} else if (dangle > 3 && dangle <= 4.2 ) {
						arcCentroid[0] *= 3.0;
						arcCentroid[1] *= 1.5;
						//console.log('4');
					} else if (dangle > 4.2 && dangle <= 5.0 ) {
						arcCentroid[0] *= 2.5;
						arcCentroid[1] *= 1.0;
						//console.log('5');
					} else {
						arcCentroid[0] *= 2.9;
						arcCentroid[1] *= 2.0;
						//console.log('6');
					}

				}
				
				return "translate(" + arcCentroid + ")";

			},
			createToken() {
				const now = Date.now();
				const diff = (now - (now % 5000));
				const rounded = new Date(diff).toISOString();
				const token = window.btoa(`${rounded}`);
				
				return token;
			}
		}
	}
</script>
<style lang="scss">
	@import "src/assets/scss/global-sass";

	.asw-poll {
		text-align:center;
		position: absolute;
		z-index: 10;
		top:-1px;
		bottom:-1px;
		color:#fff;
		background: rgba(0,0,0, 0.85);
		left:0;
		right:0;
		top:0;
		bottom:0;
		z-index: 30;
		height: 100%;
		overflow: hidden;
		// max-height: 100vh;

		@include MQ_SmallMedium() {
			right:-1px;
		}
		/*
		.asw-results.asw-fullscreen & {
			right: -1px;
			left: auto;
		}
		*/

		&_inner {
			padding: 12px;
		    overflow: auto;
			height: 100%;
			
			display: flex;
			justify-content: center;
			flex-direction: column;
			//text-align: center;

		}

		&_title {
			font-size:3em;
			line-height: 1em;
			margin:20px;
		}

		&_question_hint {
			font-size:0.8em;
			color:#7a7a7a;
			margin:20px 0;
		}

		&_result {
			margin-bottom:40px;
		}

		.button {
			border:1px solid #fff;
			border-radius:6px;
			display:inline-block;
			margin:0 auto 20px;
			cursor: pointer;
			width:140px;
			padding: 10px 50px;
			z-index: 10;
			&.active,
			&:hover {
				color: #19acf0;
			}
		}

		&_result_chart { 
			display: flex;
			justify-content: center;
			align-items: center;
			padding:50px 0;

			&_svg:not(:root) {
				overflow:visible;
			}

			&_item {
				padding: $m-spacing 0;
				white-space:nowrap;
			}
			&_name {
				display: block;
				@include tgs-font-title-s;
			}
			&_value {
				@include tgs-font-title-m;
			}
			path {
				stroke: #fff;
				stroke-width: 1px;
			}
			tspan {
				&.name {
					font-size:12px;
				}
				&.value {
					font-weight: bold;
				}
			}
		}

		// SLider Overrides
		&_slider {
			margin:20px 50px;
			min-height:100px;

			@media only screen and (max-width: 500px) {
				margin:20px 5px;

				.vue-slider {
					&-mark-label {
						font-size: 0.7em;
						&:after {
							width:20px;
							height:20px;
						}
					}
				}
			}
			.vue-slider {
				box-sizing:content-box;
				.vue-slider-rail {
					height:10px;
					width:100%;
					border-radius: 4px;
					background: rgb(201,0,0);
					background: linear-gradient(90deg, rgba(201,0,0,1) 8%, rgba(244,106,0,1) 25%, rgba(74,168,15,1) 41%, rgba(0,131,141,1) 58%, rgba(22,145,219,1) 74%, rgba(213,18,135,1) 92%);
				}
				&-dot-handle {
					width:30px;
					height:30px;
					margin-top:-24px;
					margin-left:-8px;

					//width: 200px;
					//height: 200px;
					background-color: #fff;
					border-radius: 50%;
					border-top-right-radius: 0;
					transform: rotate(135deg);
					//float: left;
					//margin-top: 50px;
					//margin-left: 20px;
					border: 2px solid #fff;
				}
				&-mark {
					cursor:pointer;
				}
				&-mark-label {
					&:after {
						content:'';
						display:block;
						width:50px;
						height:50px;
						margin:0 auto;
						background-repeat: no-repeat;
						background-size: 100% auto;
					}
				}
				&-mark:nth-child(1) {
					.vue-slider-mark-label {
						&:after {
							background-image: url(data:image/svg+xml;base64,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);
						}
					}
				}
				&-mark:nth-child(2) {
					.vue-slider-mark-label {
						&:after {
							background-image: url(data:image/svg+xml;base64,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);
						}
					}
				}
				&-mark:nth-child(3) {
					.vue-slider-mark-label {
						&:after {
							background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICA8ZGVmcz4gICAgPHBhdGggaWQ9ImEiIGQ9Ik0wIDBoMTE0djExNEgweiIvPiAgPC9kZWZzPiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgPHBhdGggZD0iTTExNiA1OWMwIDMwLjkyNy0yNS4wNzIgNTYtNTYgNTYtMzAuOTI3IDAtNTYtMjUuMDczLTU2LTU2QzQgMjguMDcxIDI5LjA3MyAzIDYwIDNjMzAuOTI4IDAgNTYgMjUuMDcyIDU2IDU2IiBmaWxsPSIjNEFBODBGIi8+ICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMgMykiPiAgICAgIDxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj4gICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4gICAgICA8L21hc2s+ICAgICAgPHBhdGggZD0iTTU3IDIuMzI2QzI2Ljg1MiAyLjMyNiAyLjMyNiAyNi44NTIgMi4zMjYgNTdjMCAzMC4xNDkgMjQuNTI2IDU0LjY3NSA1NC42NzQgNTQuNjc1czU0LjY3NC0yNC41MjYgNTQuNjc0LTU0LjY3NWMwLTMwLjE0Ny0yNC41MjYtNTQuNjczLTU0LjY3NC01NC42NzNNNTcgMTE0QzI1LjU3IDExNCAwIDg4LjQyOCAwIDU3IDAgMjUuNTcgMjUuNTcgMCA1NyAwczU3IDI1LjU3IDU3IDU3YzAgMzEuNDI4LTI1LjU3IDU3LTU3IDU3IiBmaWxsPSIjMzMzIiBtYXNrPSJ1cmwoI2IpIi8+ICAgIDwvZz4gICAgPHBhdGggZD0iTTM2IDQwYTUgNSAwIDEgMS0xMCAwIDUgNSAwIDAgMSAxMCAwTTk0IDQwYTUgNSAwIDEgMS0xMCAwIDUgNSAwIDAgMSAxMCAwIiBmaWxsPSIjRjI2MDcxIi8+ICAgIDxwYXRoIGQ9Ik00NCAzMWEzIDMgMCAxIDEtNS45OTkuMDAxQTMgMyAwIDAgMSA0NCAzMU04MSAzMWEzIDMgMCAxIDEtNiAwIDMgMyAwIDAgMSA2IDBNODEuMjUyIDU0LjUzM2MuNTk2LjIzMS44OTguOTE4LjY3NCAxLjUzMy0uMjI4LjYxNS0uODkuOTI3LTEuNDg1LjY5NC03LjE2Ny0yLjc4Mi0xNS4yMDctMS4yOTMtMjAuOTgxIDMuODg3LTUuNzc1IDUuMTgxLTguMzIxIDEzLjE5LTYuNjQ5IDIwLjkwMy4xNC42NDEtLjI1IDEuMjc3LS44NzMgMS40MjEtLjYyLjE0My0xLjIzOC0uMjYxLTEuMzc2LS45MDItMS44Ni04LjU2Ni45NzEtMTcuNDYzIDcuMzg1LTIzLjIxNyA2LjQxNC01Ljc1NSAxNS4zNDQtNy40MSAyMy4zMDUtNC4zMTl6IiBmaWxsPSIjMzMzIi8+ICA8L2c+PC9zdmc+);
						}
					}
				}
				&-mark:nth-child(4) {
					.vue-slider-mark-label {
						&:after {
							background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICA8ZGVmcz4gICAgPHBhdGggaWQ9ImEiIGQ9Ik0wIDBoMTE0djExNEgweiIvPiAgPC9kZWZzPiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgPHBhdGggZD0iTTYwIDYxYy04LjcxNyAwLTE2LjcxLTQuNzA0LTIwLjg1OC0xMi4yNzdhMS4xNiAxLjE2IDAgMCAxIC40NzgtMS41ODIgMS4xOTEgMS4xOTEgMCAwIDEgMS42MDIuNDcyYzMuNzM2IDYuODE3IDEwLjkzIDExLjA1NCAxOC43NzkgMTEuMDU0czE1LjA0My00LjIzNyAxOC43NzctMTEuMDU0YTEuMTkgMS4xOSAwIDAgMSAxLjYwMi0uNDcyIDEuMTYgMS4xNiAwIDAgMSAuNDc4IDEuNTgyQzc2LjcxIDU2LjI5NiA2OC43MTggNjEgNjAgNjEiIGZpbGw9IiMzMzMiLz4gICAgPHBhdGggZD0iTTExNiA1OWMwIDMwLjkyOC0yNS4wNzIgNTYtNTYgNTZTNCA4OS45MjggNCA1OSAyOS4wNzIgMyA2MCAzczU2IDI1LjA3MiA1NiA1NiIgZmlsbD0iIzAwODM4RCIvPiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzIDMpIj4gICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+ICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNhIi8+ICAgICAgPC9tYXNrPiAgICAgIDxwYXRoIGQ9Ik01NyAyLjMyNmMtMzAuMTQ4IDAtNTQuNjczIDI0LjUyNy01NC42NzMgNTQuNjc1IDAgMzAuMTQ3IDI0LjUyNSA1NC42NzMgNTQuNjczIDU0LjY3MyAzMC4xNDggMCA1NC42NzQtMjQuNTI2IDU0LjY3NC01NC42NzMgMC0zMC4xNDgtMjQuNTI2LTU0LjY3NS01NC42NzQtNTQuNjc1TTU3IDExNEMyNS41NyAxMTQgMCA4OC40MyAwIDU3IDAgMjUuNTcyIDI1LjU3IDAgNTcgMHM1NyAyNS41NzEgNTcgNTdjMCAzMS40My0yNS41NyA1Ny01NyA1NyIgZmlsbD0iIzMzMyIgbWFzaz0idXJsKCNiKSIvPiAgICA8L2c+ICAgIDxwYXRoIGQ9Ik0zNiA0MGE1LjAwMSA1LjAwMSAwIDEgMS0xMC4wMDItLjAwMSA1LjAwMSA1LjAwMSAwIDAgMSAxMC4wMDIgME05NCA0MGE1LjAwMSA1LjAwMSAwIDAgMS0xMCAwIDUgNSAwIDAgMSAxMCAwIiBmaWxsPSIjRjI2MDcxIi8+ICAgIDxwYXRoIGQ9Ik00NCAyOWEzIDMgMCAxIDEtNS45OTkuMDAxQTMgMyAwIDAgMSA0NCAyOU04MSAyOWEzIDMgMCAxIDEtNiAwIDMgMyAwIDAgMSA2IDAiIGZpbGw9IiMzMzMiLz4gICAgPHBhdGggZD0iTTY5IDUyLjU5NmgyOS42OTFNMzIuOTUgMjUuNTk2aDU0LjI0NyIgc3Ryb2tlPSIjMzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4gIDwvZz48L3N2Zz4=);
						}
					}
				}
				&-mark:nth-child(5) {
					.vue-slider-mark-label {
						&:after {
							background-image: url(data:image/svg+xml;base64,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);
						}
					}
				}
				&-mark:nth-child(6) {
					.vue-slider-mark-label {
						&:after {
							background-image: url(data:image/svg+xml;base64,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);
						}
					}
				}
			}
			&.happy .vue-slider-dot-handle {
				border-color:#ccc;
			}

			&.furious .vue-slider-dot-handle {border-color:#C90000;}
			&.depressed .vue-slider-dot-handle {border-color:#F46A00;}
			&.worried .vue-slider-dot-handle {border-color:#4AA80F;}
			&.meh .vue-slider-dot-handle {border-color:#00838D;}
			&.happy .vue-slider-dot-handle {border-color:#1691DB;}
			&.stoked .vue-slider-dot-handle {border-color:#D51287;}

			@media only screen and (max-width: 500px) {
				margin:20px 10px;

				.vue-slider {
					&-mark-label {
						font-size: 0.7em;
						&:after {
							width:30px;
							height:30px;
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Poll.vue